const analyses = '/analyses'
const combos = '/combos'
const programs = '/programs'
const clientHierarchy = '/client-hierarchy'

type RoutingMap = {
  [T in keyof typeof routesList]: (typeof routesList)[T]
} & {
  INITIAL_ROUTE: string
}

const routesList = {
  analyses,
  analysesAdd: `${analyses}/:type(SOIL_SAMPLE|LEAF_SAMPLE|FRUIT_SAMPLE)/add`,
  analysesEdit: `${analyses}/edit/:type(SOIL_SAMPLE|LEAF_SAMPLE|FRUIT_SAMPLE)/:analysisId/:clientId?/:farmId?/:fieldId?`,
  analysesUpload: `${analyses}/:type(SOIL_SAMPLE|LEAF_SAMPLE|FRUIT_SAMPLE)/upload`,
  clientHierarchy,
  clientHierarchyDistributorForm: `${clientHierarchy}/distributor`,
  clientHierarchyCreateClient: `${clientHierarchy}/client/add`,
  clientHierarchyEditClient: `${clientHierarchy}/client/edit`,
  clientHierarchyCreateFarm: `${clientHierarchy}/farm/add`,
  clientHierarchyEditFarm: `${clientHierarchy}/farm/edit`,
  clientHierarchySoilZones: `${clientHierarchy}/soil-zones`,
  clientHierarchyCreateField: `${clientHierarchy}/field/add`,
  clientHierarchyEditField: `${clientHierarchy}/field/edit`,
  clientHierarchyCreateFieldProgram: `${clientHierarchy}/field/program/add`,
  clientHierarchyDuplicateFieldProgram: `${clientHierarchy}/programs/:programId`,
  clientHierarchyUploadAnalysis: `${clientHierarchy}/uploadAnalysis/:type(SOIL_SAMPLE|LEAF_SAMPLE|FRUIT_SAMPLE)`,
  clientHierarchyFieldBoundariesMap: `${clientHierarchy}/field-boundaries/:assign?`,
  combos,
  comboAdd: `${combos}/add`,
  comboProductsRelative: `/products`,
  comboReviewRelative: `/review`,
  comboCopy: `${combos}/copy/:comboId`,
  comboEdit: `${combos}/edit/:comboId`,
  comboShare: `${combos}/share/:comboId`,
  programs,
  programAdd: `${programs}/add`,
  programAddCH: `${programs}/add/:clientId/:farmId/:fieldId`,
  programAddComboAdd: `${programs}/add/combo/add`,
  programAddComboEdit: `${programs}/add/combo/edit/:comboId`,
  programAddAnalysisAdd: `${programs}/add/analysis/add`,
  programAddAnalysisSelect: `${programs}/add/analysis/select`,
  programAddAnalysisUpload: `${programs}/add/analysis/upload`,
  programCopy: `${programs}/copy/:programId/:fieldId?`,
  programCopyComboAdd: `${programs}/copy/:programId/combo/add`,
  programCopyComboEdit: `${programs}/copy/:programId/combo/edit/:comboId`,
  programCopyAnalysisAdd: `${programs}/copy/:programId/analysis/add`,
  programCopyAnalysisSelect: `${programs}/copy/:programId/analysis/select`,
  programCopyAnalysisUpload: `${programs}/copy/:programId/analysis/upload`,
  programShow: `${programs}/:programId`,
  programShowHref: `${programs}`,
  recommendationShow: `${programs}/:programId/recommendation/:recommendationId/:clientId?/:farmId?/:fieldId?`,
  recommendationFertigation: `${programs}/:programId/recommendation/:recommendationId/fertigation/:clientId?/:farmId?/:fieldId?`,
  // recommendationFertigationWithSectors: `${programs}/:programId/recommendation/:recommendationId/sectors/:clientId?/:farmId?/:fieldId?`,
  recommendationShare: `${programs}/:programId/recommendation/:recId/share`,
  recommendationPrint: `${programs}/:programId/recommendation/:recommendationId/print`,
  recommendationShareOld: `${programs}/share/:recId`,
  test: '/test',
  usersettings: '/usersettings',
  users: '/users',
  userRoles: '/users/roles',
  userPermissionMap: '/users/permissions',
  maintenance: '/maintenance',
  publish: `/recommendation/publish/:reportId`,

  // BACK OFFICE
  backOffice: '/back-office',
  backOfficeMenu: '/back-office/menu',
  backOfficeStandardProducts: '/back-office/standard-products',
  backOfficeStandardProductsForm: '/back-office/standard-products/form',
  backOfficeCropSolutions: '/back-office/crop-solutions',

  // BACK OFFICE LABORATORIES
  laboratories: '/back-office/laboratories',
  laboratoriesUpdate: '/back-office/laboratories/:laboratoryId/update',

  // FOOD CHAIN
  bulks: '/bulks',
  bulkForm: '/bulks/form',
  bulkCnpDetails: '/bulks/details/:bulkId',

  /** signup-specific routes **/
  completeProfile: `/signup/complete-profile`,
  pendingAuthorization: `/signup/pending-authorization`,
  onboarding: `/signup/onboarding`,
}

const routes: RoutingMap = {
  ...routesList,
  INITIAL_ROUTE: routesList.programs,
}

export const signupRoutes = [routes.completeProfile, routes.pendingAuthorization, routes.onboarding]

export default routes
